import { ReactNode, useState } from 'react';

import SidebarContext from './context';

interface SidebarProviderProps {
  children: ReactNode;
}

const getStoredExpandedSections = (): Record<string, boolean> => {
  if (typeof window === 'undefined') return {};

  try {
    const stored = localStorage.getItem('sidebar-expanded-sections');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Failed to load sidebar state:', error);
    return {};
  }
};

const saveExpandedSections = (sections: Record<string, boolean>) => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem('sidebar-expanded-sections', JSON.stringify(sections));
  } catch (error) {
    console.warn('Failed to save sidebar state:', error);
  }
};

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>(() => {
    return getStoredExpandedSections();
  });

  const toggleSection = (sectionTitle: string) => {
    setExpandedSections((prev) => {
      const newExpandedSections = {
        ...prev,
        [sectionTitle]: !prev[sectionTitle],
      };

      saveExpandedSections(newExpandedSections);

      return newExpandedSections;
    });
  };

  return (
    <SidebarContext.Provider
      value={{
        sidebarCollapsed,
        setSidebarCollapsed,
        expandedSections,
        toggleSection,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
